import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Box, IconButton, Typography, styled } from '@mui/material';
import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import CustomTrashIcon from 'components/Icons/CustomTrashIcon';

import type { OrganizationMembersDatabase } from 'redux-store/slices/organizationOverview/types';

export interface MemberListProps {
  member: OrganizationMembersDatabase;
  isLoading: boolean;
  handleUnAssignMemberFromDevice: (member: number) => void;
}

const CustomBox = styled(Box)(({ theme }) => ({
  '&:not(:first-of-type)': {
    borderTop: `1px solid ${theme.vars.palette.grey[100]}`,
  },
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: theme.spacing(1),
  alignItems: 'center',
  padding: theme.spacing(1, 2),
}));

const MemberList: FC<MemberListProps> = ({
  member,
  isLoading,
  handleUnAssignMemberFromDevice,
}) => {
  const { t } = useTranslation();

  return (
    <CustomBox>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          gap={1}
          data-testid={`member-row-${member.id}`}
        >
          <Box display="flex" flexDirection="row" gap={1}>
            <PersonOutlineOutlinedIcon />
            <Typography data-testid="member-email">{member.email}</Typography>
          </Box>
        </Box>
        <Box
          gap={1}
          maxWidth={200}
          flexDirection="row"
          display="flex"
          alignItems="center"
          data-testid="unassign-icon-block"
        >
          {member.role === 'member' ? (
            <IconButton
              disabled={isLoading}
              onClick={() => handleUnAssignMemberFromDevice(member.id)}
              data-testid="unassign-button"
            >
              <CustomTrashIcon color="error" />
            </IconButton>
          ) : (
            <Typography
              pt={1}
              pb={1}
              variant="body1"
              color="grey.600"
              data-testid="org-admin-role-text"
            >
              {t('common:roles.org_admin_short')}
            </Typography>
          )}
        </Box>
      </Box>
    </CustomBox>
  );
};

export default MemberList;
